export const LOGIN_METHOD_KEY = 'login-method'
export const PASSWORD_LOGIN_METHOD = 'email'
export const EMAIL_PINCODE_LOGIN_METHOD = 'email_pincode'
export const GOOGLE_LOGIN_METHOD = 'google'
export const FACEBOOK_LOGIN_METHOD = 'facebook'
export const MAGIC_LINK_LOGIN_METHOD = 'passwordless'
export const FLOW_TYPES = {
  SELF_SERVICE: 'SELF_SERVICE',
}
export const MANDATORY_TIPIFICATION_KEY = 'mandatoryTipification'
